const state = {
  token: "",
  code: "",
  clientApplicationRequest: {
    applicationRequestId: "",
    creatorUsername: "",
    requestId: "",
    type: "",
    createdAt: "",
    updatedAt: "",
    metadata: {},
    status: "",
    applicationId: "",
    completedAt: "",
    url: ""
  },
  uploadingStatus: {
    total: 0,
    current: 0
  }
};
export default state;